import React from "react";
import { useStore } from "react-redux";
import mime from "mime";
import _i18n from "../reducers/i18n";

let i18n = _i18n();

export function truncateWithEllipses(text, max) {
  try {
    if (!text) {
      return "";
    }
    let res =  text.substr(0, max - 1) + (text.length > max ? "…" : "");
    return res ? res : "";
  } catch (e) {
    console.error(e);
  }
}

export const isValidEmail = (emailAdress) => {
  let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (emailAdress.match(regex)) return true;
  else return false;
};

export function GetTitleSafely(notification) {
  const store = useStore().getState();
  // since the notification-JSON differs often and sometimes has language variants and sometimes it hasn't, the title must be safely defined:
  let notificationTitle = "";
  if (notification?.title) {
    if (notification.title.hasOwnProperty(store.language)) {
      notificationTitle = notification.title;
    } else {
      notificationTitle = notification.title;
    }
  }
  return notificationTitle;
}

export const getHighlightedText = (text, highlight) => {
  // Split on highlight term and include term into parts, ignore case
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  /* console.log(parts,highlight) */
  return (
    <span>
      {" "}
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part?.toLowerCase() === highlight?.toLowerCase()
              ? { color: "#98BCC4" }
              : {}
          }
        >
          {part}
        </span>
      ))}{" "}
    </span>
  );
};

export const validateField = (field) => {
  return field === "";
};

export const allow_docs_mimetypes = [
  // ✅ PDF
  "application/pdf",

  // ✅ Microsoft Word (Windows & Mac)
  "application/msword", // DOC (Word 97-2003)
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX (Word)

  // ✅ Microsoft Excel (Windows & Mac)
  "application/vnd.ms-excel", // XLS (Excel 97-2003)
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX (Excel)

  // ✅ Microsoft PowerPoint (Windows & Mac)
  "application/vnd.ms-powerpoint", // PPT (PowerPoint 97-2003)
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // PPTX (PowerPoint)

  // ✅ Plain Text (TXT)
  "text/plain",

  // ✅ Apple iWork Files (Mac)
  "application/vnd.apple.pages", // Apple Pages
  "application/vnd.apple.numbers", // Apple Numbers
  "application/vnd.apple.keynote", // Apple Keynote
];

export const allow_images_mimetypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/webp",
  "image/svg+xml",
  "image/x-icon",
  "image/heif",
  "image/heic",
];

export const allow_videos_mimetypes = [
  // "video/mp4",
  // "video/mpeg",
  // "video/webm",
  // "video/quicktime",
  "video/*",
];

export const docs_enum = allow_docs_mimetypes.join(",");
export const images_enum = "image/*";
export const videos_enum = "video/*";

export const getFileExtention = (type) => {
  return mime.getExtension(type);
};

export const categoryItems = [
  { id: "operation", category: "Bedienen und Einrichten", docsCount: 0 },
  { id: "setup", category: "Rüsten", docsCount: 0 },
  { id: "maintenance", category: "Wartung und Service", docsCount: 0 },
  { id: "safety", category: "Sicherheit", docsCount: 0 },
  { id: "internalinstructions", category: "Interne Anweisungen", docsCount: 0 },
];

export const sortNumericallyThenAlphabetically = (
  array,
  keys,
  finalFormRequired
) => {
  if (array.length) {
    let data = array.sort((a, b) => {
      keys.split(".").map((key) => {
        // generic like array["key1"]["key2"]....
        a = a[key];
        b = b[key];
      });
      const numA = parseInt(a); // Extract leading number, or NaN if none
      const numB = parseInt(b);

      if (isNaN(numA) && isNaN(numB)) {
        // Both have no numbers, sort alphabetically
        return a?.localeCompare(b);
      }
      if (isNaN(numA)) return 1; // No number goes last
      if (isNaN(numB)) return -1; // Number goes first
      return numA - numB; // Sort by numeric value
    });

    if (finalFormRequired === "object") {
      let obj = {};
      data.map((dt) => {
        obj[dt.nodeid] = dt;
      });
      return obj;
    }

    return data;
  } else {
    return array;
  }
};

export const KPI_dummy_data = [
  {
    numeric_title_1: "622",
    numeric_title_2: "h",
    _title: "MTBF",
    _description: "Zeitraum (gesamt)",
  },
  {
    numeric_title_1: "21",
    numeric_title_2: "/ 26",
    _title: "Wartungen",
    _description: "durchgeführt",
  },
  {
    numeric_title_1: "8",
    numeric_title_2: "",
    _title: "Ungelpante Stillstände",
    _description: "letzte 12 Monate",
  },
];

export const getRandomSubset = (array, maxSize) => {
  let result = [];

  array.forEach((item) => {
    if (Math.random() < 0.5) {
      result.push(item);
    }
  });

  // Ensure the result is not empty
  if (result.length === 0) {
    result.push(array[Math.floor(Math.random() * array.length)]);
  }

  // Limit the result to the desired maxSize
  return result.slice(0, maxSize);
};

export const counterBasedRepititions = [
  // {
  //   key: "",
  //   value: "",
  //   label: "Kein Zeitinterval",
  // },

  {
    key: "onetime",
    value: "",
    label: i18n.maintenance_repetition_onetime,
  },
  {
    key: "1w",
    value: "1",
    label: i18n.maintenance_repetition_oneweek,
  },
  {
    key: "2w",
    value: "2",
    label: i18n.maintenance_repetition_twoweek,
  },
  {
    key: "1m",
    value: "1",
    label: i18n.maintenance_repetition_month,
  },
  {
    key: "2m",
    value: "2",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "3m",
    value: "3",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "6m",
    value: "6",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "12m",
    value: "12",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "18m",
    value: "18",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "24m",
    value: "24",
    label: i18n.maintenance_repetition_months,
  },
  {
    key: "36m",
    value: "36",
    label: i18n.maintenance_repetition_months,
  },  {
    key: "48m",
    value: "48",
    label: i18n.maintenance_repetition_months,
  },
];



export function addWeeks(date, weeks) {
  const d = new Date(date);
  d.setDate(d.getDate() + weeks * 7);
  return d;
}

export function addMonths(date, months) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
}

export function dateToInputValue(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function nextDateFromKey(key, base) {
  if (!key || key === "onetime") return base;
  if (key.endsWith("w")) {
    const weeks = parseInt(key, 10);
    return addWeeks(base, weeks);
  }
  if (key.endsWith("m")) {
    const months = parseInt(key, 10);
    return addMonths(base, months);
  }
  return base;
}


function sortByName(a, b) {
  return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
}

function deepSortSubscriber(subscriber) {
  if (subscriber.site) {
    const site = subscriber.site;

    if (Array.isArray(site.hasarea)) {
      site.hasarea.sort((a, b) => sortByName(a.area, b.area));

      site.hasarea = site.hasarea.map(areaEntry => {
        if (Array.isArray(areaEntry.area?.hasequipment)) {
          areaEntry.area.hasequipment.sort((a, b) => sortByName(a.equipment, b.equipment));
        }
        return areaEntry;
      });
    }

    if (Array.isArray(site.hasequipment)) {
      site.hasequipment.sort((a, b) => sortByName(a.equipment, b.equipment));
    }

    subscriber.site = site;

  } else if (subscriber.area) {
    const area = subscriber.area;

    if (Array.isArray(area.hasequipment)) {
      area.hasequipment.sort((a, b) => sortByName(a.equipment, b.equipment));
    }

    subscriber.area = area;

  } else if (subscriber.equipmentpool) {
    const pool = subscriber.equipmentpool;

    if (Array.isArray(pool.hasequipment)) {
      pool.hasequipment.sort((a, b) => sortByName(a.equipment, b.equipment));
    }

    subscriber.equipmentpool = pool;
  }

  return subscriber;
}


export function getCounterNodeIdByTypeNodeId(data, typeNodeId) {
  for (const item of data) {
    const counter = item.counter;
    const countertype = counter.hascountertype?.[0]?.countertype;

    if (countertype?.nodeid === typeNodeId) {
      return counter.nodeid || null;
    }
  }
  return null;
}


// sorting our main data from Dashboard Page

export function sortUserData(data) {
  return data.map(userObj => {
    userObj.user.issubscriberof.sort((a, b) => {
      const getName = obj =>
        (obj.site && obj.site.name) ||
        (obj.area && obj.area.name) ||
        (obj.equipmentpool && obj.equipmentpool.name) || '';

      return getName(a).localeCompare(getName(b), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });

    userObj.user.issubscriberof = userObj.user.issubscriberof.map(deepSortSubscriber);

    return userObj;
  });
}


// sorting the ree data inside Profile Page Deopdowns

export function sortNumericallyAlphabeticallyTreeByTitle(nodes) {
  if (!Array.isArray(nodes)) return [];

  // Sort current level by `title`
  nodes.sort((a, b) => {

    console.log(a,b);
    return a && b && a?.title?.localeCompare(b.title, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });

  // Recursively sort children if present
  nodes.forEach(node => {
    if (Array.isArray(node.children)) {
      node.children = sortNumericallyAlphabeticallyTreeByTitle(node.children);
    }
  });

  return nodes;
}


export const equipmentCurrencies = [
  { "label": "EUR", "value": "EUR" },
  { "label": "BAM", "value": "BAM" },
  { "label": "BGN", "value": "BGN" },
  { "label": "CZK", "value": "CZK" },
  { "label": "DKK", "value": "DKK" },
  { "label": "GBP", "value": "GBP" },
  { "label": "HUF", "value": "HUF" },
  { "label": "MKD", "value": "MKD" },
  { "label": "NOK", "value": "NOK" },
  { "label": "PLN", "value": "PLN" },
  { "label": "RON", "value": "RON" },
  { "label": "RSD", "value": "RSD" },
  { "label": "SEK", "value": "SEK" },
  { "label": "CHF", "value": "CHF" },
  { "label": "TRL", "value": "TRL" },
  { "label": "BRL", "value": "BRL" },
  { "label": "CAD", "value": "CAD" },
  { "label": "CNY", "value": "CNY" },
  { "label": "UAH", "value": "UAH" },
  { "label": "USD", "value": "USD" }
]
